import { Location } from '@app/shared/routes';
import { RouteHelper } from '@utils/helpers/routeHelper';

export interface CreateBuildingFormLocationParams {
  venueId: string;
}

export const CreateBuildingFormLocation = new Location<
  CreateBuildingFormLocationParams
>({
  path: '/facility-management/venues/:venueId/buildings/create',
  pathParamDefs: {
    venueId: RouteHelper.stringParamValidation()
  }
});

export interface EditBuildingFormLocationParams {
  venueId: string;
  buildingId: string;
}

export const EditBuildingFormLocation = new Location<
  EditBuildingFormLocationParams
>({
  path: '/facility-management/venues/:venueId/buildings/:buildingId/edit',
  pathParamDefs: {
    venueId: RouteHelper.stringParamValidation(),
    buildingId: RouteHelper.stringParamValidation()
  }
});
